(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react")) : factory(root["react"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, function(__WEBPACK_EXTERNAL_MODULE__297__) {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 435:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => /* binding */ components_ReactSimpleRange
});

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(297);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/utils.js
var EVENT_TYPES = {
  TOUCH: "TOUCH_EVENT",
  MOUSE: "MOUSE_EVENT",
  KEYBOARD: "KEYBOARD_EVENT"
};
var checkValidity = function checkValidity(_ref) {
  var min = _ref.min,
      max = _ref.max,
      step = _ref.step,
      defaultValue = _ref.defaultValue;
  if (max < min) console.error("max must be > min");
  if (min > max) console.error("min must be < max");
  if (max % step !== 0) console.error("max must be evenly divisible by step"); // todo check defaultValue within range?
};
var clampValue = function clampValue(val, min, max) {
  return Math.max(min, Math.min(val, max));
};
var getRatio = function getRatio(value, min, max) {
  return Math.max(value - min, 0) * 100 / (max - min);
};
var isArrowKey = function isArrowKey(keyCode) {
  return keyCode === 37 || keyCode === 38 || keyCode === 39 || keyCode === 40;
};
var getEventType = function getEventType(event) {
  if (event.touches) return EVENT_TYPES.TOUCH;
  if (event.keyCode) return EVENT_TYPES.KEYBOARD;
  return EVENT_TYPES.MOUSE;
};
;// CONCATENATED MODULE: ./src/components/SliderThumb.js



var SliderThumb = function SliderThumb(_ref) {
  var customThumb = _ref.customThumb,
      disableThumb = _ref.disableThumb,
      position = _ref.position,
      thumbSize = _ref.thumbSize,
      sliderSize = _ref.sliderSize,
      color = _ref.color,
      vertical = _ref.vertical;
  var defaultThumb;
  var thumbCentering = (sliderSize - thumbSize) * 0.5;
  var thumbWrapperStyles = {
    position: "absolute",

    get left() {
      return !vertical ? "".concat(position, "%") : undefined;
    },

    get top() {
      return !vertical ? "0px" : undefined;
    },

    get bottom() {
      return !vertical ? undefined : "".concat(position, "%");
    },

    get marginTop() {
      return !vertical ? "".concat(thumbCentering, "px") : undefined;
    },

    get marginLeft() {
      return !vertical ? "-".concat(thumbSize * 0.5, "px") : "".concat(thumbCentering, "px");
    },

    get marginBottom() {
      return !vertical ? undefined : "-".concat(thumbSize * 0.5, "px");
    }

  };

  if (!customThumb) {
    var defaultThumbStyles = {
      backgroundColor: "".concat(color),
      opacity: disableThumb ? "0" : "1",
      borderRadius: "100%",
      height: "".concat(thumbSize, "px"),
      width: "".concat(thumbSize, "px")
    };
    defaultThumb = /*#__PURE__*/external_react_default().createElement("div", {
      style: defaultThumbStyles
    });
  }

  return /*#__PURE__*/external_react_default().createElement("div", {
    "data-testid": "slider-thumb",
    style: thumbWrapperStyles
  }, customThumb, defaultThumb && defaultThumb);
};

SliderThumb.propTypes = {
  position: (prop_types_default()).number,
  offsetTop: (prop_types_default()).number,
  offsetLeft: (prop_types_default()).number,
  sliderSize: (prop_types_default()).number,
  thumbSize: (prop_types_default()).number,
  color: (prop_types_default()).string,
  vertical: (prop_types_default()).bool,
  disableThumb: (prop_types_default()).bool,
  customThumb: (prop_types_default()).node
};
/* harmony default export */ const components_SliderThumb = (SliderThumb);
;// CONCATENATED MODULE: ./src/components/SliderLabel.js



var SliderLabel = function SliderLabel(_ref) {
  var position = _ref.position,
      color = _ref.color,
      vertical = _ref.vertical,
      value = _ref.value,
      thumbSize = _ref.thumbSize,
      sliderSize = _ref.sliderSize;
  var labelCentering = -10 + sliderSize * 0.5;
  var labelVerticalOffset = 8 + thumbSize * 0.6;
  var labelWrapperStyles = {
    position: "absolute",
    backgroundColor: color,
    color: "#fff",
    fontSize: "12px",
    fontFamily: "sans-serif",
    textAlign: "center",
    margin: "0",
    zIndex: "5",
    width: "20px",
    height: "20px",
    borderRadius: "2px",

    get bottom() {
      return !vertical ? undefined : "".concat(position, "%");
    },

    get left() {
      return !vertical ? "".concat(position, "%") : undefined;
    },

    get top() {
      return !vertical ? "-30px" : undefined;
    },

    get marginLeft() {
      return !vertical ? "-10px" : "".concat(labelCentering, "px");
    },

    get marginBottom() {
      return !vertical ? undefined : "".concat(labelVerticalOffset, "px");
    }

  };
  var pointerStyles = {
    position: "absolute",
    left: "50%",
    marginLeft: "-4px",
    bottom: "-4px",
    borderColor: "transparent",
    borderStyle: "solid",
    width: "0",
    height: "0",
    borderWidth: "4px 4px 0 4px",
    borderTopColor: color,
    zIndex: "4"
  };
  return /*#__PURE__*/external_react_default().createElement("div", {
    "data-testid": "slider-label",
    style: labelWrapperStyles
  }, /*#__PURE__*/external_react_default().createElement("span", null, value), /*#__PURE__*/external_react_default().createElement("div", {
    style: pointerStyles
  }));
};

SliderLabel.propTypes = {
  position: (prop_types_default()).number,
  color: (prop_types_default()).string,
  vertical: (prop_types_default()).bool,
  value: (prop_types_default()).number,
  thumbSize: (prop_types_default()).number,
  sliderSize: (prop_types_default()).number
};
/* harmony default export */ const components_SliderLabel = (SliderLabel);
;// CONCATENATED MODULE: ./src/components/SliderTrack.js



var SliderTrack = function SliderTrack(_ref) {
  var trackLength = _ref.trackLength,
      color = _ref.color,
      vertical = _ref.vertical;
  var trackStyles = {
    backgroundColor: color,

    get width() {
      return !vertical ? "".concat(trackLength, "%") : "100%";
    },

    get height() {
      return !vertical ? "100%" : "".concat(trackLength, "%");
    },

    get position() {
      return !vertical ? undefined : "absolute";
    },

    get bottom() {
      return !vertical ? undefined : "0";
    }

  };
  return /*#__PURE__*/external_react_default().createElement("div", {
    "data-testid": "slider-track",
    style: trackStyles
  });
};

SliderTrack.propTypes = {
  trackLength: (prop_types_default()).number,
  color: (prop_types_default()).string,
  vertical: (prop_types_default()).bool
};
/* harmony default export */ const components_SliderTrack = (SliderTrack);
;// CONCATENATED MODULE: ./src/components/ReactSimpleRange.js
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable no-console */







function noOp() {}

var ReactSimpleRange = function ReactSimpleRange(props) {
  var sliderRef = (0,external_react_.useRef)(null);

  var _useState = (0,external_react_.useState)(props.defaultValue || props.value || 0),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = (0,external_react_.useState)(getRatio(value, props.min, props.max)),
      _useState4 = _slicedToArray(_useState3, 2),
      ratio = _useState4[0],
      setRatio = _useState4[1];

  var thumbSize = props.thumbSize || props.disableThumb ? 0 : props.sliderSize * 2;

  var _useState5 = (0,external_react_.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      drag = _useState6[0],
      setDrag = _useState6[1];

  var _useState7 = (0,external_react_.useState)(false),
      _useState8 = _slicedToArray(_useState7, 2),
      displayLabel = _useState8[0],
      setDisplayLabel = _useState8[1];

  checkValidity(props);
  var didInitialMount = (0,external_react_.useRef)(false);
  var previousValue = (0,external_react_.useRef)(value);
  (0,external_react_.useEffect)(function () {
    var valueChanged = value !== previousValue.current;

    if (valueChanged) {
      props.onChange && props.onChange({
        value: value,
        ratio: ratio
      }, props.id);
      previousValue.current = value;
    }
  }, [value]);
  (0,external_react_.useEffect)(function () {
    if (didInitialMount.current === false) {
      didInitialMount.current = true;
      return;
    }

    if (drag === false) {
      props.onChangeComplete({
        value: value,
        ratio: ratio
      }, props.id);
    }
  }, [drag]);

  var handleInteractionStart = function handleInteractionStart(event) {
    var eventType = getEventType(event);
    var leftMouseButton = 0;
    if (eventType === EVENT_TYPES.MOUSE && event.button !== leftMouseButton) return;
    updateSliderValue(event, eventType);
    addEvents(eventType);
    setDrag(true);
    setDisplayLabel(true);
  };

  var handleInteractionEnd = function handleInteractionEnd() {
    setDrag(false);
    setDisplayLabel(false);
    removeEvents();
  };

  var onMouseOrTouchMove = function onMouseOrTouchMove(event) {
    var eventType = getEventType(event);
    updateSliderValue(event, eventType);
    event.preventDefault();
    event.stopPropagation();
  };

  var getSliderInfo = function getSliderInfo() {
    var sl = sliderRef.current;
    return {
      bounds: sl.getBoundingClientRect(),
      length: sl.clientWidth,
      height: sl.clientHeight
    };
  };

  var addEvents = function addEvents(type) {
    switch (type) {
      case EVENT_TYPES.MOUSE:
        {
          document.addEventListener("mousemove", onMouseOrTouchMove);
          document.addEventListener("mouseup", handleInteractionEnd);
          break;
        }

      case EVENT_TYPES.TOUCH:
        {
          document.addEventListener("touchmove", onMouseOrTouchMove, {
            passive: false
          });
          document.addEventListener("touchend", handleInteractionEnd);
          break;
        }

      default: // keyboard events handled separately

    }
  };

  var removeEvents = function removeEvents() {
    document.removeEventListener("mousemove", onMouseOrTouchMove);
    document.removeEventListener("mouseup", handleInteractionEnd);
    document.removeEventListener("touchmove", onMouseOrTouchMove, {
      passive: false
    });
    document.removeEventListener("touchend", handleInteractionEnd);
  };

  var updateSliderValue = function updateSliderValue(event, eventType) {
    var max = props.max,
        min = props.min,
        vertical = props.vertical;
    var xCoords = (eventType !== EVENT_TYPES.TOUCH ? event.pageX : event.touches[0].pageX) - window.pageXOffset;
    var yCoords = (eventType !== EVENT_TYPES.TOUCH ? event.pageY : event.touches[0].pageY) - window.pageYOffset; // compare position to slider length to get percentage

    var position;
    var lengthOrHeight;

    if (!vertical) {
      position = xCoords - getSliderInfo().bounds.left;
      lengthOrHeight = getSliderInfo().length;
    } else {
      lengthOrHeight = getSliderInfo().height;
      position = lengthOrHeight - (yCoords - getSliderInfo().bounds.top);
    }

    var percent = clampValue(+(position / lengthOrHeight).toFixed(2), 0, 1); // convert percentage -> value then match value to notch as per props/state.step

    var rawValue = valueFromPercent(percent);
    var value = calculateMatchingNotch(rawValue);
    setValue(value);
    setRatio(getRatio(value, min, max));
  };

  var valueFromPercent = function valueFromPercent(percentage) {
    var range = props.max - props.min;
    return range * percentage + props.min;
  };

  var calculateMatchingNotch = function calculateMatchingNotch(value) {
    var step = props.step,
        max = props.max,
        min = props.min;
    var values = [];

    for (var i = min; i <= max; i++) {
      values.push(i);
    }

    var notches = []; // find how many entries in values are divisible by step (+min,+max)

    for (var _i2 = 0, _values = values; _i2 < _values.length; _i2++) {
      var s = _values[_i2];

      if (s === min || s === max || s % step === 0) {
        notches.push(s);
      }
    } // reduce over the potential notches and find which is the closest


    return notches.reduce(function (prev, curr) {
      if (Math.abs(curr - value) < Math.abs(prev - value)) {
        return curr;
      }

      return prev;
    });
  };

  var vertical = props.vertical,
      sliderSize = props.sliderSize,
      disableThumb = props.disableThumb,
      disableTrack = props.disableTrack,
      customThumb = props.customThumb,
      label = props.label,
      trackColor = props.trackColor,
      thumbColor = props.thumbColor,
      verticalSliderHeight = props.verticalSliderHeight,
      eventWrapperPadding = props.eventWrapperPadding;
  var eventWrapperStyle = {
    height: "100%",
    position: "relative",
    cursor: "pointer",
    margin: "0 auto",

    get padding() {
      return !vertical ? "".concat(eventWrapperPadding, "px 0") : "0 ".concat(eventWrapperPadding, "px");
    },

    get width() {
      return !vertical ? "auto" : "".concat(sliderSize, "px");
    }

  };
  var sliderStyle = {
    backgroundColor: props.sliderColor,
    position: "relative",
    overflow: "visible",

    get height() {
      return !vertical ? "".concat(sliderSize, "px") : verticalSliderHeight;
    },

    get width() {
      return !vertical ? "100%" : "".concat(sliderSize, "px");
    }

  };

  var handleKeyDownEvent = function handleKeyDownEvent(event) {
    if (isArrowKey(event.keyCode) === false) return;
    setDrag(true);
    setDisplayLabel(true);
    event.preventDefault();
    var isPositiveKey = event.keyCode === 38 || event.keyCode === 39;
    var isNegativeKey = event.keyCode === 37 || event.keyCode === 40;

    if (isPositiveKey) {
      incrementValueByStep();
    } else if (isNegativeKey) {
      decrementValueByStep();
    }
  };

  var incrementValueByStep = function incrementValueByStep() {
    var min = props.min,
        max = props.max,
        step = props.step;
    var newValue = clampValue(value + step, min, max);
    setValue(newValue);
    setRatio(getRatio(newValue, min, max));
  };

  var decrementValueByStep = function decrementValueByStep() {
    var max = props.max,
        min = props.min,
        step = props.step;
    var newValue = clampValue(value - step, min, max);
    setValue(newValue);
    setRatio(getRatio(newValue, min, max));
  };

  var handleKeyUpEvent = function handleKeyUpEvent(event) {
    if (isArrowKey(event.keyCode)) {
      setDrag(false);
      setDisplayLabel(false);
    }
  };

  return /*#__PURE__*/external_react_default().createElement("div", {
    style: eventWrapperStyle,
    onMouseDown: handleInteractionStart,
    onTouchStart: handleInteractionStart,
    onKeyDown: handleKeyDownEvent,
    onKeyUp: handleKeyUpEvent,
    tabIndex: "0",
    "data-testid": "wrapper-events"
  }, /*#__PURE__*/external_react_default().createElement("div", {
    "data-testid": "wrapper-slider",
    ref: sliderRef,
    style: sliderStyle
  }, disableTrack === false ? /*#__PURE__*/external_react_default().createElement(components_SliderTrack, {
    trackLength: ratio,
    color: trackColor,
    vertical: vertical
  }) : null, label && displayLabel ? /*#__PURE__*/external_react_default().createElement(components_SliderLabel, {
    position: ratio,
    vertical: vertical,
    color: trackColor,
    value: value,
    sliderSize: sliderSize,
    thumbSize: thumbSize
  }) : null, disableThumb === false && /*#__PURE__*/external_react_default().createElement(components_SliderThumb, {
    position: ratio,
    vertical: vertical,
    customThumb: customThumb,
    thumbSize: thumbSize,
    sliderSize: sliderSize,
    color: thumbColor,
    disableThumb: disableThumb,
    value: value
  })));
};

ReactSimpleRange.propTypes = {
  children: (prop_types_default()).element,
  min: (prop_types_default()).number,
  max: (prop_types_default()).number,
  step: (prop_types_default()).number,
  value: (prop_types_default()).number,
  defaultValue: (prop_types_default()).number,
  onChange: (prop_types_default()).func,
  onChangeComplete: (prop_types_default()).func,
  vertical: (prop_types_default()).bool,
  verticalSliderHeight: (prop_types_default()).string,
  eventWrapperPadding: (prop_types_default()).number,
  label: (prop_types_default()).bool,
  disableTrack: (prop_types_default()).bool,
  disableThumb: (prop_types_default()).bool,
  sliderColor: (prop_types_default()).string,
  trackColor: (prop_types_default()).string,
  thumbColor: (prop_types_default()).string,
  sliderSize: (prop_types_default()).number,
  thumbSize: (prop_types_default()).number,
  id: (prop_types_default()).string
};
ReactSimpleRange.defaultProps = {
  min: 0,
  max: 100,
  step: 1,
  onChange: noOp,
  onChangeComplete: noOp,
  vertical: false,
  verticalSliderHeight: "100px",
  eventWrapperPadding: 8,
  label: false,
  disableTrack: false,
  disableThumb: false,
  sliderColor: "#B9B9B9",
  trackColor: "#009688",
  thumbColor: "#009688",
  sliderSize: 4,
  id: ""
};
/* harmony default export */ const components_ReactSimpleRange = (ReactSimpleRange);

/***/ }),

/***/ 703:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 697:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(703)();
}


/***/ }),

/***/ 414:
/***/ ((module) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 297:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__297__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => module['default'] :
/******/ 				() => module;
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop)
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	// module exports must be returned from runtime so entry inlining is disabled
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(435);
/******/ })()
;
});